import { render } from "./APIIntegrations.vue?vue&type=template&id=83f866cc&scoped=true"
import script from "./APIIntegrations.vue?vue&type=script&lang=js"
export * from "./APIIntegrations.vue?vue&type=script&lang=js"

import "./APIIntegrations.vue?vue&type=style&index=0&id=83f866cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f866cc"]])

export default __exports__